import React from "react";

import "../../styles/premium-shell.css";

/**
 * Site-wide ambient background (grid, noise, orbs). Render once inside the router.
 */
export const PremiumShellBackdrop: React.FC = () => (
  <div className="zoniq-premium-backdrop" aria-hidden>
    <div className="zoniq-premium-backdrop__grid" />
    <div className="zoniq-premium-backdrop__noise" />
    <div className="zoniq-premium-backdrop__orb zoniq-premium-backdrop__orb--red" />
    <div className="zoniq-premium-backdrop__orb zoniq-premium-backdrop__orb--cyan" />
    <div className="zoniq-premium-backdrop__orb zoniq-premium-backdrop__orb--teal" />
    <div className="zoniq-premium-backdrop__orb zoniq-premium-backdrop__orb--gold" />
  </div>
);
